import React, { useContext, useEffect, useRef, useState } from "react";
import { theme } from "../assets/theme";
import Nav2 from "../Nav2";
import YouHearMeImage from "../assets/images/ym-you-hear-me-cover.jpg";
import AfterYouImage from "../assets/images/after-you-cover.jpeg";
import BTM from "../assets/images/BlackThunderMountain.webp";
import RunningbackImage from "../assets/images/2pack.jpg";
import { FaSpotify, FaYoutube } from "react-icons/fa6";
import { SiApplemusic, SiTidal, SiYoutubemusic } from "react-icons/si";
import PEAK from "../assets/music/YouHearMe/PEAK.mp3";
import NOWUCME from "../assets/music/YouHearMe/Now U C Me.mp3";
import PARKINGLOT from "../assets/music/YouHearMe/Parking Lot.mp3";
import OTG from "../assets/music/YouHearMe/OTG.mp3";
import YDKS from "../assets/music/YouHearMe/YDKS.mp3";
import Dogfight from "../assets/music/YouHearMe/Dogfight.mp3";
import AfterYou from "../assets/music/After You/After You.mp3";
import MollySong from "../assets/music/Molly.mp3";
import Runningback from "../assets/music/runningback.mp3";
import BeFreeCover from "../assets/images/be-free-cover.gif";
import RedCloud from "../assets/images/red-cloud.png";
import MollyVid from "../assets/videos/molly.mp4";
import { FaPause, FaBackward, FaForward, FaPlay } from "react-icons/fa";
import { MusicPlayerContext } from "../contexts/MusicPlayerContext";
import useMusicPlayer from "../hooks/useMusicPlayer";
import { GiPlayButton } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import YMLogo from "../assets/YM_Logo-Black.png";
import "./Music.css";
import interact from "interactjs";
import { BeFreeSection } from "./BeFreeSection";

const spacing = 4;
const iconSize = 5;

const AlbumTemplate = {
  title: "",
  cover: BTM,
  releaseDate: "2025",
  songs: "",
  spotify: "",
  youtube: "",
  appleMusic: "",
  youtubeMusic: "",
};

const YouHearMeSongs = [
  {
    title: "PEAK",
    src: PEAK,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
  {
    title: "Now U C Me",
    src: NOWUCME,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
  {
    title: "Parking Lot",
    src: PARKINGLOT,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
  {
    title: "Out The Gates",
    src: OTG,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
  {
    title: "YDKS!",
    src: YDKS,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
  {
    title: "Dogfight (feat. Jermaine Paul & Fahim Erfan)",
    src: Dogfight,
    cover: YouHearMeImage,
    releaseDate: "May 6, 2022",
  },
];

const YouHearMeAlbum = {
  title: "You Hear Me",
  cover: YouHearMeImage,
  releaseDate: "May 6, 2022",
  songs: YouHearMeSongs,
  spotify:
    "https://open.spotify.com/album/3iootcVwIrKdCXo3MO1GTW?si=Txhk_NOuRf-M5ptNnSFjcw&utm_medium=share&utm_source=linktree&nd=1&dlsi=127c7a882bc748dc",
  youtube:
    "https://www.youtube.com/playlist?list=OLAK5uy_mM29PrfM0IYGsm4-P_VwaftXvv_uKJWc4",
  appleMusic:
    "https://music.apple.com/us/album/you-hear-me/1622590135?at=1000lHKX&ct=linktree_http&itscg=30200&itsct=lt_m",
  tidal: "https://listen.tidal.com/album/227626579",
  youtubeMusic:
    "https://music.youtube.com/playlist?list=OLAK5uy_mM29PrfM0IYGsm4-P_VwaftXvv_uKJWc4",
};

const AfterYouSongs = [
  {
    title: "After You",
    src: AfterYou,
    cover: AfterYouImage,
    releaseDate: "January 7, 2025",
  },
];

const AfterYouAlbum = {
  title: "After You",
  cover: AfterYouImage,
  releaseDate: "January 7, 2025",
  songs: AfterYouSongs,
  spotify: "https://open.spotify.com/track/0b7aJV5tqhOmCVc7nubAjJ",
  youtube: "https://www.youtube.com/watch?v=BsEOtQTElTw",
  appleMusic: "https://music.apple.com/us/album/after-you-single/1783600556",
  youtubeMusic:
    "https://music.youtube.com/playlist?list=OLAK5uy_lJz6hluDeGDB252BpGexLupAT3HT6HbS4",
};

const Molly = [
  {
    title: "Molly",
    src: MollySong,
    cover: BTM,
    releaseDate: "January 7, 2025",
  },
];

const MollyAlbum = {
  title: "Molly",
  cover: BTM,
  releaseDate: "September 24, 2025",
  songs: Molly,
  // spotify: "https://open.spotify.com/track/0b7aJV5tqhOmCVc7nubAjJ",
  youtube: "https://www.youtube.com/watch?v=FhDuvafS1og",
  // appleMusic: "https://music.apple.com/us/album/after-you-single/1783600556",
  // youtubeMusic:
  //   "https://music.youtube.com/playlist?list=OLAK5uy_lJz6hluDeGDB252BpGexLupAT3HT6HbS4",
};

const RunningbackSong = [
  {
    title: "Runn!ngback",
    src: Runningback,
    cover: RunningbackImage,
    releaseDate: "January 7, 2025",
  },
];

const RunningBackAlbum = {
  title: "Runn!ngback",
  cover: RunningbackImage,
  releaseDate: "Feburary 5, 2025",
  songs: RunningbackSong,
  // spotify: "https://open.spotify.com/track/0b7aJV5tqhOmCVc7nubAjJ",
  youtube: "https://www.youtube.com/watch?v=FhDuvafS1og",
  // appleMusic: "https://music.apple.com/us/album/after-you-single/1783600556",
  // youtubeMusic:
  //   "https://music.youtube.com/playlist?list=OLAK5uy_lJz6hluDeGDB252BpGexLupAT3HT6HbS4",
};

const BeFreeAlbum = {
  title: "Be Free",
  cover: BeFreeCover,
  releaseDate: "2026",
  songs: [
    {
      title: "Runn!ngback",
      src: Runningback,
      cover: RunningbackImage,
      releaseDate: "January 7, 2025",
    },
  ],
  spotify: "",
  youtube: "",
  appleMusic: "",
  youtubeMusic: "",
};

const NullSong = {
  title: "",
  src: "",
  cover: "",
  releaseDate: "",
};

const TestAlbum = {};

const albums = [
  YouHearMeAlbum,
  AfterYouAlbum,
  MollyAlbum,
  RunningBackAlbum,
  BeFreeAlbum,
  // TestAlbum,
];

const linkIconMap = {
  spotify: <FaSpotify className={`h-[${iconSize}vw] w-[${iconSize}vw]`} />,
  youtube: <FaYoutube className={`h-[${iconSize}vw] w-[${iconSize}vw]`} />,
  appleMusic: (
    <SiApplemusic className={`h-[${iconSize}vw] w-[${iconSize}vw]`} />
  ),
  tidal: <SiTidal className={`h-[${iconSize}vw] w-[${iconSize}vw]`} />,
  youtubeMusic: (
    <SiYoutubemusic className={`h-[${iconSize}vw] w-[${iconSize}vw]`} />
  ),
};

export default function Music() {
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const [listOpen, setListOpen] = useState(false);

  const {
    queue,
    setQueue,
    playing,
    setPlaying,
    duration,
    setDuration,
    currentTime,
    setCurrentTime,
    currentTrack,
    setCurrentTrack,
    selectedAlbum,
    setselectedAlbum,
  } = useMusicPlayer(audioRef);

  useEffect(() => {
    queue.length > 0 && !playing && setCurrentTrack(queue[0]);
  }, [queue]);

  const handleLoadedAudioData = (event) => {
    const audioElement = event.target;
    setDuration(audioElement.duration);
    audioElement?.play();
  };

  return (
    <MusicPlayerContext.Provider
      value={{
        queue,
        setQueue,
        playing,
        setPlaying,
        duration,
        setDuration,
        currentTime,
        setCurrentTime,
        currentSong: currentTrack,
        setCurrentSong: setCurrentTrack,
      }}
    >
      <div
        className={`relative flex min-h-screen flex-col bg-[${theme.main}] max-w-screen items-center overflow-clip `}
      >
        <Nav2
          backButtonOnClick={() => {
            return selectedAlbum ? setselectedAlbum(null) : navigate("/");
          }}
        />

        {selectedAlbum ? (
          selectedAlbum.title === "Be Free" ? (
            <BeFreeSection />
          ) : (
            <div
              key={selectedAlbum?.title}
              className={`flex flex-col gap-${spacing} ${selectedAlbum?.title !== "Be Free" ? "p-8" : ""} ${currentTrack && queue.length > 0 && "pb-[22.5vh]"} max-w-[100vw] justify-center`}
            >
              <div className="relative mb-2 flex flex-col items-center gap-0.5">
                {/* <div
                id="cloud-img-container"
                className="overflow- relative flex justify-center"
              >
                <img
                  src={RedCloud}
                  className="absolute bottom-[-63%] left-0 min-w-[135%]"
                  alt="cloud-1"
                />
                <img
                  src={RedCloud}
                  className="absolute bottom-[-50%] left-[-20%] min-w-[95%]"
                  alt="cloud-2"
                />
                <img
                  src={RedCloud}
                  className="absolute bottom-[-55%] left-[30%] min-w-[95%]"
                  alt="cloud-3"
                />
                <img
                  id="product-image"
                  alt="product"
                  src={selectedAlbum?.cover}
                  className="z-[1] aspect-square w-3/4 bg-transparent object-contain lg:w-[45%]"
                />
                <img
                  src={RedCloud}
                  className="absolute bottom-[-45%] right-[30%] z-[2] min-w-[115%]"
                  alt="cloud-4"
                />
                <img
                  src={RedCloud}
                  className="absolute bottom-[-55%] right-[-30%] z-[2] min-w-[145%]"
                  alt="cloud-5"
                />
              </div> */}
                <img
                  id="product-image"
                  alt="product"
                  src={selectedAlbum?.cover}
                  className="z-[1] aspect-square w-3/4 bg-transparent object-contain lg:w-[45%]"
                />
                <div className="z-[10] flex flex-col items-center gap-0.5">
                  <p className="text-[min(5vw,40px)] font-[900]">
                    {selectedAlbum?.title}
                  </p>
                  <p className="text-[min(3vw,40px)] font-[700]">
                    Release Date: {selectedAlbum?.releaseDate}
                  </p>
                </div>
              </div>
              <div id="link-bar" className="flex justify-center gap-2">
                {selectedAlbum?.spotify && (
                  <a
                    href={selectedAlbum?.spotify}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {linkIconMap.spotify}
                  </a>
                )}
                {selectedAlbum?.youtube && (
                  <a
                    href={selectedAlbum?.youtube}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {linkIconMap.youtube}
                  </a>
                )}
                {selectedAlbum?.appleMusic && (
                  <a
                    href={selectedAlbum?.appleMusic}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {linkIconMap.appleMusic}
                  </a>
                )}
                {selectedAlbum?.tidal && (
                  <a
                    href={selectedAlbum?.tidal}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {linkIconMap.tidal}
                  </a>
                )}
                {selectedAlbum?.youtubeMusic && (
                  <a
                    href={selectedAlbum?.youtubeMusic}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {linkIconMap.youtubeMusic}
                  </a>
                )}
              </div>

              <div className="flex flex-col gap-[5px]">
                {selectedAlbum.songs.map((song, i) => (
                  <div
                    className={`grid grid-cols-[1fr_auto] items-center justify-between gap-1 rounded-md border-[2px]  px-4 py-2`}
                    key={`song-${i}`}
                    style={{
                      borderColor: theme.secondary,
                      background: theme.accent,
                    }}
                  >
                    <p className="">{song.title}</p>
                    <GiPlayButton
                      size={20}
                      onClick={() => {
                        setQueue((prevQueue) => {
                          return [...prevQueue, song];
                        });
                        // setPlaying(true);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )
        ) : (
          <div
            className={`py-4 px-${spacing} grid grid-cols-1 items-start justify-center sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-${spacing} bg-[${theme.main}] ${currentTrack && queue.length > 0 && "pb-[22.5vh]"}`}
          >
            {albums.map((album) => (
              <div
                key={album.title}
                className={`flex flex-col gap-${spacing} p-2 hover:bg-white`}
              >
                <div
                  className="box-border flex cursor-pointer flex-col items-center gap-0.5"
                  onClick={() => {
                    if (album.title === "Be Free") {
                      setQueue([]);
                      setCurrentTrack(null);
                    }
                    setselectedAlbum(album);
                  }}
                >
                  <img
                    id="product-image"
                    alt="product"
                    src={album.cover}
                    className={`aspect-square h-full w-full bg-transparent object-contain ${album.title === "Be Free" && " object-cover object-bottom"} `}
                  />
                  <p className="text-[25px] font-[900]">{album.title}</p>
                  <p className="text-[14px] font-[700]">{album.releaseDate}</p>
                </div>
                <div
                  id="link-bar"
                  className="flex items-center justify-center gap-2 "
                >
                  {album.spotify && (
                    <a href={album.spotify} target="_blank" rel="noreferrer">
                      {linkIconMap.spotify}
                    </a>
                  )}
                  {album.youtube && (
                    <a href={album.youtube} target="_blank" rel="noreferrer">
                      {linkIconMap.youtube}
                    </a>
                  )}
                  {album.appleMusic && (
                    <a href={album.appleMusic} target="_blank" rel="noreferrer">
                      {linkIconMap.appleMusic}
                    </a>
                  )}
                  {album.tidal && (
                    <a href={album.tidal} target="_blank" rel="noreferrer">
                      {linkIconMap.tidal}
                    </a>
                  )}
                  {album.youtubeMusic && (
                    <a
                      href={album.youtubeMusic}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {linkIconMap.youtubeMusic}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {currentTrack && queue.length > 0 && (
          <>
            <Controls listOpen={listOpen} setListOpen={setListOpen} />
            <audio
              id="ym-music-player"
              ref={audioRef}
              className="hidden"
              onLoadedData={handleLoadedAudioData}
              src={currentTrack.src}
              onEnded={() => {
                const currentIndex = queue.findIndex(
                  (song) => song.title === currentTrack.title,
                );
                if (currentIndex < queue.length - 1) {
                  setCurrentTrack(queue[currentIndex + 1]);
                }
              }}
              controls
              autoPlay
              playsInline
            />
          </>
        )}
      </div>
    </MusicPlayerContext.Provider>
  );
}

function Controls({ listOpen, setListOpen }) {
  const {
    queue,
    playing,
    setPlaying,
    currentSong,
    currentTime,
    duration,
    setCurrentTime,
    setDuration,
    setCurrentSong,
  } = useContext(MusicPlayerContext);
  useEffect(() => {
    const audio = document.getElementById("ym-music-player");
    if (audio) {
      if (audio.paused) {
        setPlaying(false);
      } else {
        setPlaying(true);
      }
      audio.addEventListener("timeupdate", () => {
        setCurrentTime(audio.currentTime);
      });
      audio.addEventListener("loadeddata", () => {
        setDuration(audio.duration);
      });
    }
  }, [playing, currentTime, duration]);

  // useEffect(() => {
  //   const dragContainer = document.getElementById("testItem");
  //   const dragBar = interact("#testItemBar").draggable({
  //     listeners: {
  //       move(event) {
  //         const deltaY = event.dy;

  //         // Get current height
  //         const style = window.getComputedStyle(dragContainer);
  //         const currentHeight = parseFloat(style.height);

  //         // Update height (with minimum limit)
  //         const newHeight = currentHeight - deltaY;
  //         const minHeight = 0.1 * window.innerHeight;
  //         const maxHeight = window.innerHeight;

  //         // Allow free drag, but clamp at min during drag
  //         dragContainer.style.height = `${Math.max(minHeight, Math.min(newHeight, maxHeight))}px`;
  //       },
  //     },
  //     onend(event) {
  //       const style = window.getComputedStyle(dragContainer);
  //       const currentHeight = parseFloat(style.height);
  //       const halfScreen = window.innerHeight / 2;

  //       let finalHeight;

  //       // if (currentHeight >= halfScreen) {
  //       //   // Snap to 3/4 of screen height
  //       //   finalHeight = 0.75 * window.innerHeight;
  //       // } else {
  //       //   // Snap to 1/10 of screen height
  //       //   finalHeight = 0.2 * window.innerHeight;
  //       // }

  //       if (currentHeight >= halfScreen) {
  //         finalHeight = 0.75 * window.innerHeight;

  //         dragContainer.style.transition = "height 0.2s ease";
  //         dragContainer.style.height = `${finalHeight}px`;
  //       } else {
  //         //   // Let container shrink to fit its children
  //         dragContainer.style.transition = "height 0.2s ease";

  //         //   // First, animate to current height to start transition
  //         //   // const currentHeight = dragContainer.offsetHeight;
  //         dragContainer.style.height = `auto`;

  //         //   // Next, use requestAnimationFrame to remove height so CSS transition works
  //         // requestAnimationFrame(() => {
  //         //   dragContainer.style.height = "auto";
  //         // });
  //       }

  //       // Animate the transition (optional)
  //       dragContainer.style.transition = "height 0.2s ease";
  //       dragContainer.style.height = `${finalHeight}px`;
  //       dragContainer.style.bottom = "0dvh";
  //       console.log(`${finalHeight}px`);

  //       // dragContainer.innerHTML += `<p style="height: 100px; aspect-ratio: 1/1; background-color: green;">${finalHeight}px</p>`;

  //       // Remove transition after it's done to prevent side effects on future drags
  //       setTimeout(() => {
  //         dragContainer.style.transition = "";
  //       }, 200);
  //     },
  //   });
  // }, []);
  const containerRef = useRef(null);
  const grabQueue = useRef(null);
  const [initialHeight, setInitialHeight] = useState(null);
  const [chevronUp, setChevronUp] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (el) {
      setInitialHeight(el.scrollHeight);
    }

    const dragBar = interact("#testItemBar").draggable({
      // cursorChecker: ,
      listeners: {
        move(event) {
          const el = containerRef.current;
          const deltaY = event.dy;
          const currentHeight = parseFloat(getComputedStyle(el).height);
          const newHeight = currentHeight - deltaY;
          const minHeight = 0.1 * window.innerHeight;
          const maxHeight = window.innerHeight;
          el.style.height = `${Math.max(minHeight, Math.min(newHeight, maxHeight))}px`;
        },

        end(event) {
          const el = containerRef.current;
          const currentHeight = parseFloat(getComputedStyle(el).height);
          const halfScreen = window.innerHeight / 2;
          const velocityY = event.velocityY;

          const downwardFlick = velocityY > 1.5; // Tune this threshold if needed
          const upwardFlick = velocityY < -1.5; // Tune this threshold if needed
          // const v = event.
          if (currentHeight >= halfScreen || upwardFlick) {
            const finalHeight = 0.75 * window.innerHeight;
            el.style.transition = "height 0.2s ease";
            el.style.height = `${finalHeight}px`;
            setChevronUp(true);
            setIsExpanded(true);

            setTimeout(() => {
              el.style.transition = "";
            }, 200);
          } else if (currentHeight < halfScreen || downwardFlick) {
            const baseHeight = initialHeight;

            el.style.transition = "height 0.2s ease";
            el.style.height = `${currentHeight}px`;

            requestAnimationFrame(() => {
              el.style.height = `${baseHeight}px`;
            });

            el.addEventListener(
              "transitionend",
              () => {
                el.style.transition = "";
                el.style.height = "auto";
              },
              { once: true },
            );

            setChevronUp(false);
            setIsExpanded(false);
          }
        },
      },
    });

    return () => {
      dragBar.unset();
    };
  }, [initialHeight]);

  const handlePlayPause = () => {
    const audio = document.getElementById("ym-music-player");
    if (audio && !audio.paused) {
      setPlaying(false);
      audio.pause();
    } else {
      setPlaying(true);
      audio.play();
    }
  };

  return (
    <>
      {listOpen ? (
        <div
          className={`fixed bottom-[-15dvh] flex min-h-[100dvh] w-full flex-col items-center gap-4  rounded-t-md bg-[white]`}
        >
          <div
            className="flex w-full items-center justify-center"
            onClick={() => {
              setListOpen(false);
            }}
          >
            <svg
              className="h-full w-[15vw]"
              viewBox="0 0 150 100"
              // xmlns="http://www.w3.org/2000/svg"
              strokeLinecap="round"
            >
              <path
                d="M25 60 L75 80 L125 60"
                stroke={theme.main}
                className=" w-[15vw] stroke-[15px]"
                fill="none"
              />
            </svg>
          </div>

          {queue &&
            queue.map((song) => {
              return (
                <div
                  onClick={() => {
                    setCurrentSong(song);
                    console.log(song);
                    // setListOpen(false);
                  }}
                  className="flex w-full gap-2 bg-transparent/15"
                >
                  {/* {JSON.stringify(song)} */}
                  <img
                    id="product-image"
                    alt="product"
                    src={song.cover}
                    className="aspect-square h-[10vw] w-[10vw] bg-transparent object-contain "
                  />
                  <div className="">{song.title}</div>
                </div>
              );
            })}
        </div>
      ) : (
        <div
          style={{
            background: theme.accent,
            color: theme.secondary,
          }}
          ref={containerRef}
          id="testItem"
          className={`fixed bottom-[0dvh] flex w-full flex-col items-center justify-between p-2 max-md:p-1`}
        >
          <div className="flex w-full  items-center justify-center">
            <div
              // onClick={() => setListOpen(true)}
              id="testItemBar"
              className={`h-[5px] w-[15vw] max-w-[150px] cursor-grab rounded-full bg-[${theme.main}]`}
              style={{
                cursor: "grab",
              }}
            />
          </div>
          <div
            ref={grabQueue}
            id="grabQueue"
            style={{
              scrollbarWidth: "thin",
            }}
            className={`box-border flex w-full flex-col items-start gap-2 overflow-y-auto px-2 pt-2 transition-all duration-300 ${
              isExpanded
                ? "max-h-[60vh] flex-1"
                : "hidden max-h-0 overflow-hidden"
            }`}
          >
            {queue &&
              queue.map((song, index) => {
                return (
                  <div
                    key={`item-${index}`}
                    onClick={() => {
                      const audio = document.getElementById("ym-music-player");
                      if (currentSong.src === song.src) {
                        audio.currentTime = 0;
                        audio.pause();
                        setCurrentTime(0);
                        audio.play();
                      }
                      setCurrentSong(song);
                      console.log(song, currentSong);
                      // setListOpen(false);
                    }}
                    className="box-border flex w-full cursor-pointer gap-2 rounded bg-transparent/15 p-2 hover:bg-white hover:outline hover:outline-2 hover:outline-black"
                  >
                    {/* {JSON.stringify(song)} */}
                    <img
                      id="product-image"
                      alt="product"
                      src={song.cover}
                      className="aspect-square h-[40px] bg-transparent object-contain"
                    />
                    <div className="">{song.title}</div>
                  </div>
                );
              })}
          </div>
          <PlayerSongData handlePlayPause={handlePlayPause} />
        </div>
      )}
    </>
  );
}

function PlayerSongData({ handlePlayPause }) {
  const {
    queue,
    playing,
    currentTime,
    duration,
    setCurrentTime,
    setDuration,
    currentSong,
    setCurrentSong,
  } = useContext(MusicPlayerContext);
  const playerIconSizeClass = `h-[2vh] w-[2vh]`;
  const handleChange = (e) => {
    const audio = document.getElementById("ym-music-player");
    if (audio) {
      audio.currentTime = e.target.value;
      setCurrentTime(e.target.value);
      setDuration(audio.duration);
    }
  };
  useEffect(() => {
    // const audio = document.getElementById("ym-music-player");
    // if (audio) {
    //   audio.src = currentSong.src;
    //   audio.play();
    // }
    // console.log(currentTime, duration, currentSong);
    // const musicSlider = document.getElementById("custom-input");
    // musicSlider.style.setProperty("-webkit-slider-thumb", )
  }, [currentSong, currentTime, duration]);
  return (
    <div className="relative flex max-h-[15vh] w-full gap-[10px]">
      <img
        id="product-image"
        alt="product"
        src={currentSong.cover}
        className=" aspect-square max-h-[10vh] bg-transparent object-contain"
      />
      <div className="flex w-full flex-col pr-[5px]">
        <p className="line-clamp-1 text-ellipsis text-[min(2vh,40px)] font-[900]">
          {currentSong && currentSong.title}
        </p>
        {/* {true && <p className="text-[min(2.5vw,40px)] font-[700]">Featuring</p>} */}
        {/* <style>
          {`.musicSlider::-webkit-slider-thumb {
              -webkit-appearance: none;
              appearance: none;
              width: 20px;
              height: 20px;
              border-radius: 100%;
              cursor: pointer;
            }`}
        </style> */}
        <input
          type="range"
          min={0}
          max={duration}
          value={currentTime}
          onChange={handleChange}
          class="custom-input"
          className="musicSlider"
          style={{
            "-webkit-appearance": "none",
            // background: theme.main,
            background: `linear-gradient(to right, ${theme.main} ${(currentTime / duration) * 100}%, lightgray ${(currentTime / duration) * 100}%)`,
            marginTop: "5px",
            marginBottom: "10px",
            borderRadius: "15px",
          }}
        />
        <div
          className=" flex w-full"
          // className="justify-between"
        >
          <div className="flex-1 ">
            {Math.floor(currentTime / 60)}:
            {currentTime % 60 < 10
              ? `0${Math.round(currentTime % 60)}`
              : Math.round(currentTime % 60)}
          </div>
          <div className="flex max-h-[4vh] w-1/3 flex-1 flex-col gap-4 self-center pr-[1vw]">
            <div className="absolute bottom-2 left-1/2 flex -translate-x-1/2 justify-center gap-5 ">
              <FaBackward
                // size={iconSize}
                className={playerIconSizeClass}
                color={theme.secondary}
                onClick={() => {
                  const audio = document.getElementById("ym-music-player");
                  if (audio) {
                    const currentIndex = queue.findIndex(
                      (song) => song.title === currentSong.title,
                    );
                    if (currentIndex > 0) {
                      setCurrentSong(queue[currentIndex - 1]);
                    }
                  }
                }}
              />
              {playing ? (
                <FaPause
                  // size={iconSize}
                  color={theme.secondary}
                  onClick={handlePlayPause}
                  className={playerIconSizeClass}
                />
              ) : (
                <FaPlay
                  // size={iconSize}
                  color={theme.secondary}
                  onClick={handlePlayPause}
                  className={playerIconSizeClass}
                />
              )}
              <FaForward
                // size={iconSize}
                color={theme.secondary}
                onClick={() => {
                  const audio = document.getElementById("ym-music-player");
                  if (audio) {
                    const currentIndex = queue.findIndex(
                      (song) => song.title === currentSong.title,
                    );
                    if (currentIndex < queue.length - 1) {
                      console.log(queue[currentIndex + 1]);
                      setCurrentSong(queue[currentIndex + 1]);
                    }
                  }
                }}
                className={playerIconSizeClass}
                style={{
                  marginLeft: "-2px",
                }}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-row-reverse items-end justify-items-end">
            <div className="">
              {Math.floor(duration / 60)}:
              {duration % 60 < 10
                ? `0${Math.round(duration % 60)}`
                : Math.round(duration % 60)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
